import {env} from '../../environment'

export const fetchVatSets = () => {
  const url = env.getServiceHost() + 'products/vatSets?version=3'

  return fetch(url).then(response => response.json())
}
